import { render, staticRenderFns } from "./PageOrderDetail.vue?vue&type=template&id=7d40db58&scoped=true"
import script from "./PageOrderDetail.vue?vue&type=script&lang=js"
export * from "./PageOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./PageOrderDetail.vue?vue&type=style&index=0&id=7d40db58&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d40db58",
  null
  
)

export default component.exports